import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API, auth, money, riyadhTodayStr, riyadhDaysAgoStr, hasRole, FINANCE_ROLES, HR_ROLES, MANAGE_ROLES } from '../shared';
import KpiCard from '../KpiCard';
import { SectionCard } from '../../../../components/dashboard/TodaySchedule';

export default function ExecutiveTab({ user }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  useEffect(() => {
    (async () => {
      const g = (url) => axios.get(`${API}${url}`, auth()).then((r) => r.data).catch(() => null);
      const calls = { stats: g('/statistics/dashboard'), governance: g('/governance-items') };
      if (hasRole(user, FINANCE_ROLES)) calls.finance = g('/financial/dashboard');
      if (hasRole(user, HR_ROLES)) calls.hr = g('/employees/statistics/summary');
      if (hasRole(user, MANAGE_ROLES)) {
        calls.board = g('/board-members');
        calls.coaching = g(`/coach-studio/org/reports?date_from=${riyadhDaysAgoStr(30)}&date_to=${riyadhTodayStr()}`);
      }
      const keys = Object.keys(calls);
      const results = await Promise.all(Object.values(calls));
      const out = {};
      keys.forEach((k, i) => { out[k] = results[i]; });
      setData(out);
      setLoading(false);
    })();
  }, [user]);

  if (loading) {
    return <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">{[1, 2, 3, 4].map((i) => <div key={i} className="h-24 animate-pulse rounded-xl bg-slate-100" />)}</div>;
  }

  const governanceItems = Array.isArray(data.governance) ? data.governance : [];
  const boardMembers = data.board?.members || [];

  return (
    <div className="space-y-4" data-testid="executive-tab">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        <KpiCard icon="users" label="اللاعبون النشطون" value={data.stats?.total_players ?? 0} testId="kpi-players" />
        <KpiCard icon="userGroup" label="الفرق المنافسة" value={data.stats?.total_teams ?? 0} testId="kpi-teams" />
        <KpiCard icon="calendar" label="المباريات" value={data.stats?.total_matches ?? 0} testId="kpi-matches" />
        <KpiCard icon="trophy" label="البطولات" value={data.stats?.total_tournaments ?? 0} testId="kpi-tournaments" />
        {data.hr && <KpiCard icon="briefcase" label="الموظفون النشطون" value={data.hr.active_count ?? 0} testId="kpi-employees" />}
        {data.finance && (
          <KpiCard icon="banknotes" label="الصافي المالي" value={money(data.finance.net_balance)} accent={data.finance.net_balance >= 0 ? 'text-teal-700' : 'text-red-600'} testId="kpi-net" />
        )}
        <KpiCard icon="flag" label="عناصر الحوكمة" value={governanceItems.length} testId="kpi-governance" />
        {data.board && <KpiCard icon="building" label="أعضاء مجلس الإدارة" value={boardMembers.length} testId="kpi-board" />}
        {data.coaching && <KpiCard icon="whistle" label="جلسات فنية (٣٠ يوم)" value={data.coaching.sessions_completed ?? 0} sub="مشتركة مع المنشأة" testId="kpi-coaching" />}
      </div>
      {!data.finance && !data.hr && !data.coaching && (
        <SectionCard title="ملاحظة" icon="info" testId="executive-scope-note">
          <p className="text-sm text-slate-500">بعض الأقسام (المالية/الموارد البشرية/العمل الفني) تظهر هنا فقط لأصحاب الصلاحية المناسبة.</p>
        </SectionCard>
      )}
    </div>
  );
}
